import { defineCustomElement } from "vue";
import { Register } from "..";
import F360BannerBwa from "./F360BannerBwa.ce.vue";

const _register: Register = {
  register() {
    if (!customElements.get("vc-banner-bwa")) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const CustomElement = defineCustomElement(F360BannerBwa as any);
      customElements.define("vc-banner-bwa", CustomElement);
    }
  }
};

export default _register;
